export default __webpack_public_path__ + "static/media/cust-app.381e11da.png";